<template>
  <v-card flat>
    <v-row class="px-2">
      <v-col cols="4">
        <v-autocomplete filled hide-details v-model="filterObj.type" :label="$t('message.common.type')" :no-data-text="$t('message.common.noRecords')" :items="listReportFilterType" item-text="title" item-value="value"></v-autocomplete>
      </v-col>
      <v-col cols="4" v-if="listOfRecords && listOfRecords.length > 0">
        <v-btn color="success" small dark @click="generateAsXLSX" fab class="button-small mx-1">
          <v-icon>mdi-file-excel</v-icon>
        </v-btn>
        <v-btn color="red" small dark fab @click="generateAsPDF" class="button-small mx-1">
          <v-icon>mdi-file-pdf</v-icon>
        </v-btn>
        <v-btn color="blue" small dark fab @click="isValidEmail = false, sendEmailData.emailIds = [], sendEmailData.type = 1, emailDialog = true" class="button-small mx-1">
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>
        <v-btn color="primary" small dark fab @click="showHideColumnFilter" class="button-small mx-1">
          <v-icon>mdi-filter-outline</v-icon>
        </v-btn>
        <v-btn color="info" small dark fab @click="toggleSortFilter" class="button-small mx-1">
          <v-icon>mdi-sort</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-progress-linear indeterminate v-if="filterSpin" color="primary darken-2"></v-progress-linear>
    <v-row v-if="listOfRecords && listOfRecords.length > 0">
      <v-col cols="4" sm="3"></v-col>
      <v-col cols="8" sm="9">
        <v-row>
          <v-col cols="12" class="pt-0 pb-0" v-if="columnFilterToggle">
            <v-card class="pa-2">
              <transition name="slide-fade">
                <v-row class="ma-2">
                  <v-col cols="12" class="pa-0" md="2" sm="4" v-for="(field, index) in columnFilterFields" :key="`${index}_${field.name}`">
                    <v-checkbox v-if="field.name === 'all'" hide-details :label="field.text" v-model="filteredFields.all"></v-checkbox>
                    <v-checkbox v-else hide-details :label="field.text" v-model="filteredFields.otherItems" :value="field.name"></v-checkbox>
                  </v-col>
                </v-row>
              </transition>
            </v-card>
          </v-col>
          <v-col cols="12" class="pt-1 pb-0" v-if="sortFilterToggle">
            <v-card class="pa-2">
              <v-row class="ma-2">
                <v-col cols="4" sm="3" md="3">
                  <v-select filled hide-details item-text="text" v-model="filterObj.sort_by" item-value="order" :items="reportHeaders" :label="$t('message.common.select')" ></v-select>
                </v-col>
                <v-col cols="4" sm="3" md="2">
                  <v-radio-group row v-model="filterObj.sort_asc_or_desc">
                    <v-radio label="ASC" value="asc"></v-radio>
                    <v-radio label="DESC" value="desc"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="4" sm="3" md="2" class="mt-2">
                  <v-btn small color="primary" @click="applyFilter" fab>{{ $t('message.timer.go') }}</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="pa-1">
      <v-col cols="4" sm="3">
        <v-card>
          <v-card-text class="pt-2">
            <v-form ref="filterForm">
              <v-autocomplete :no-data-text="$t('message.common.noRecords')" v-model="filterObj.projects" :items="myProjects"
                item-text="name" item-value="id" hide-details clearable :label="$t('message.layout.projects')" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.projects.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
              <v-autocomplete v-if="filterObj.type === 2" :no-data-text="$t('message.common.noRecords')" v-model="filterObj.activities" :items="listOfActivities"
                :label="$t('message.layout.activities')" clearable hide-details item-text="name"  item-value="id" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.activities.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
              <v-autocomplete :no-data-text="$t('message.common.noRecords')" v-model="filterObj.employees" :items="getUsers"
                :label="$t('message.reports.selectEmployees')" clearable hide-details item-text="name"  item-value="id" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.employees.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
              <v-menu v-model="fromDateMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field clearable readonly v-on="on" hide-details v-model="filterObj.from" prepend-icon="mdi-calendar" @click:clear="filterObj.fromDatePicker = null" :label="$t('message.common.startDate')"></v-text-field>
                </template>
                <v-date-picker v-model="filterObj.fromDatePicker" @input="fromDateMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
              </v-menu>
              <v-menu v-model="tillDateMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field clearable readonly v-on="on" hide-details v-model="filterObj.till" prepend-icon="mdi-calendar" @click:clear="filterObj.tillDatePicker = null" :label="$t('message.common.endDate')"></v-text-field>
                </template>
                <v-date-picker v-model="filterObj.tillDatePicker" :min="filterObj.fromDatePicker" @input="tillDateMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
              </v-menu>
              <v-autocomplete :no-data-text="$t('message.common.noRecords')" v-model="filterObj.worktypes" :items="getWorktypes"
                item-text="name" item-value="id" clearable hide-details :label="$t('message.layout.worktypes')" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.worktypes.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
              <v-autocomplete :no-data-text="$t('message.common.noRecords')" v-model="filterObj.status" :items="hourStates"
                item-text="text" item-value="value" clearable hide-details :label="$t('message.common.state')" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.status.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
              <v-checkbox value color="primary" hide-details v-model="filterObj.showonlysum" :label="$t('message.reports.onlySum')"></v-checkbox>
              <v-checkbox value color="primary" hide-details v-model="filterObj.showestimation" :label="$t('message.reports.showEstimation')"></v-checkbox>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-flex text-center>
                <v-btn color="success" :loading="filterSpin" @click="applyFilter" class="ma-1">{{ $t('message.reports.runReport') }}
                </v-btn>
                <v-btn color="error" @click="clearForm" class="ma-1">{{ $t('message.common.clear') }}</v-btn>
              </v-flex>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="8" sm="9" class="px-1" ref="getReportContent">
        <template v-if="listOfRecords && listOfRecords.length > 0">
          <preview-report :list="listOfRecords" :filter="filterObj" :reportFilter="reportFilter" :headers="clonedHeaders"></preview-report>
        </template>
        <v-alert icon="mdi-information-outline" v-else prominent text type="info">
          {{ $t('message.common.noRecords') }}
        </v-alert>
      </v-col>
    </v-row>
    <v-dialog v-model="emailDialog" persistent width="400">
      <v-form ref="sendEmailForm">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>{{ $t('message.reports.sendReport') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="sendEmailData.emailIds" :label="$t('message.common.email')" :rules="$_requiredValidation"></v-text-field>
            {{ $t('message.reports.emailNote') }}
            <v-autocomplete v-model="sendEmailData.type" :items="listSentEmailOptions" :no-data-text="$t('message.common.noRecords')" :label="$t('message.common.type')" item-text="title" item-value="value"></v-autocomplete>
          </v-card-text>
          <v-card-actions class="text-lg-right">
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="sentReportLoading" dark @click="sendReport"> {{ $t('message.common.ok') }} </v-btn>
            <v-btn color="error" dark @click="emailDialog = false, sendEmailData.emailIds = null">{{ $t('message.common.cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '../../assets/json/constants.json'
import moment from 'moment'
import { api } from '../../plugins/axios_settings'
export default {
  data () {
    return {
      fromDateMenu: false,
      tillDateMenu: false,
      filterObj: {
        type: 1,
        from: moment().startOf('month').format('DD.MM.YYYY'),
        till: moment().endOf('month').format('DD.MM.YYYY'),
        sort_asc_or_desc: 'asc',
        sort_by: 4
      },
      filterSpin: false,
      columnFilterToggle: false,
      filteredFields: {
        all: false,
        otherItems: []
      },
      listOfRecords: [],
      clonedHeaders: [],
      sortOrder: '',
      sortFilterToggle: false,
      listOfActivities: [],
      sendEmailData: {
        emailIds: ''
      },
      emailDialog: false,
      isValidEmail: false,
      sentReportLoading: false,
      isFalseonlyAllCkbx: false,
      myProjects: [],
      reportFilter: {},
      disableFilterWatch: false
    }
  },
  computed: {
    ...mapGetters(['getUsers', 'getWorktypes', 'getActivities', 'getuserDetails']),
    listReportFilterType () {
      return [{
        value: 1,
        title: this.$t('message.reports.perProject')
      }, /* {
        value: 2,
        title: this.$t('message.reports.perActivity')
      },  */{
        value: 3,
        title: this.$t('message.reports.perEmployee')
      }]
    },
    listSentEmailOptions () {
      return [{
        value: 1,
        title: this.$t('message.reports.onlyPdf')
      }, {
        value: 2,
        title: this.$t('message.reports.onlyXlsx')
      }, {
        value: 3,
        title: this.$t('message.reports.both')
      }]
    },
    reportHeaders () {
      return [{
        text: this.$t('message.common.date'),
        name: 'date',
        width: '8%',
        tab: 1,
        order: 4,
        isdefault: true
      }, {
        text: this.$t('message.stamp.activity'),
        name: 'activity_name',
        width: '10%',
        tab: 2,
        order: 2,
        isdefault: true
      }, {
        text: this.$t('message.common.employee'),
        name: 'employee_name',
        width: '12%',
        tab: 3,
        order: 3,
        isdefault: true
      }, /* {
        text: this.$t('message.timer.workType'),
        name: 'worktype_name',
        width: '10%',
        tab: 4,
        order: 1
      }, */ {
        text: this.$t('message.reports.userCost'),
        name: 'employee_cost',
        width: '8%',
        tab: 5,
        order: 6
      }, {
        text: this.$t('message.timer.hours'),
        name: 'hours',
        width: '8%',
        tab: 6,
        order: 5,
        isdefault: true
      }, {
        text: this.$t('message.common.state'),
        name: 'state_name',
        width: '14%',
        tab: 7,
        order: 8
      }, {
        text: this.$t('message.timer.finder'),
        name: 'finder_name',
        width: '12%',
        tab: 8,
        order: 9
      }, {
        text: this.$t('message.timer.findersFee'),
        name: 'findersfee',
        width: '10%',
        tab: 9,
        order: 10
      }, {
        text: this.$t('message.common.comments'),
        name: 'comments',
        width: '18%',
        tab: 10,
        order: 7,
        isdefault: true
      }]
    },
    columnFilterFields () {
      return [{
        name: 'all',
        text: 'All'
      }, ...this.reportHeaders]
    },
    hourStates () {
      return [{
        text: this.$t('message.timer.notDelivered'),
        value: CONSTANTS.NOT_DELIVERED
      }, {
        text: this.$t('message.timer.delivered'),
        value: CONSTANTS.DELIVERED
      }, {
        text: this.$t('message.timer.approved'),
        value: CONSTANTS.APPROVED
      }, {
        text: this.$t('message.timer.notApprovedMsg'),
        value: CONSTANTS.NOT_APPROVED
      }]
    }
  },
  created () {
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getWorktypes')
    this.$store.dispatch('getActivities')
  },
  components: {
    'preview-report': () => import('../../components/Report/PreviewReport')
  },
  watch: {
    'filterObj.projects' (val) {
      if (this.filterObj.type === 2) {
        if (val && val.length > 0) {
          this.getActivityByProject(val)
        } else this.listOfActivities = []
      }
      this.filterObj.activities = null
    },
    'filterObj.type' () {
      this.listOfRecords = []
      // this.clearForm()
    },
    'filterObj.fromDatePicker' (val) {
      if (val) {
        this.filterObj.from = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'filterObj.tillDatePicker' (val) {
      if (val) {
        this.filterObj.till = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'filteredFields.all' (val) {
      if (!this.disableFilterWatch) {
        if (val) {
          let getHeaders = this.$format.cloneVariable(this.reportHeaders)
          this.filteredFields.otherItems = [...getHeaders.map(x => x.name)]
        } else if (!this.isFalseonlyAllCkbx) {
          this.filteredFields.otherItems = []
        }
        this.isFalseonlyAllCkbx = false
      }
    },
    'filteredFields.otherItems' (val) {
      if (!this.disableFilterWatch) {
        if (val && val.length < this.reportHeaders.length) {
          this.isFalseonlyAllCkbx = true
          this.filteredFields.all = false
        } else this.filteredFields.all = true
      }
      this.filterByHeadersToReport(val)
    }
  },
  mounted () {
    this.clonedHeaders = this.$format.cloneVariable(this.reportHeaders)
    /* Filter default fields set section */
    const filterByColumns = window.localStorage.getItem('FilterByColumns')
    let otherItemFields = filterByColumns ? JSON.parse(filterByColumns) : null
    if (!otherItemFields || (otherItemFields && otherItemFields.length < 1)) {
      const fields = this.$format.cloneVariable(this.reportHeaders).filter(x => x.isdefault)
      const defaultFields = fields.sort(this.compareTab)
      otherItemFields = [...defaultFields.map(x => x.name)]
    }
    this.disableFilterWatch = true
    this.filteredFields = {
      all: otherItemFields.length === this.reportHeaders.length,
      otherItems: otherItemFields
    }
    setTimeout(() => {
      this.disableFilterWatch = false
    })
    /* --ends-- */
    this.getMyPrjects()
  },
  methods: {
    getMyPrjects () {
      let date = moment().format('MM-DD-YYYY')
      const url = this.getuserDetails && this.getuserDetails.isadmin ? 'projects' : `projects/get_my_projects?date=${date}`
      this.$api.execute('get', url)
        .then((response) => {
          this.myProjects = this.$format.cloneVariable(response.data)
        })
    },
    applyFilter () {
      this.filterSpin = true
      let transformData = { date: { list: ['from', 'till'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
      let model = this.$format.formatModel(this.filterObj, transformData)
      let url = ''
      switch (this.filterObj.type) {
        case 1:
          url = 'preview_per_project'
          break
        case 2:
          url = 'preview_per_activity'
          break
        case 3:
          url = 'preview_per_employee'
          break
        default:
          break
      }
      this.$api.execute('post', `reports/${url}`, model)
        .then((response) => {
          if (response && response.data) this.listOfRecords = response.data
          this.reportFilter = this.$format.cloneVariable(this.filterObj)
        })
        .finally(() => {
          this.filterSpin = false
        })
    },
    clearForm () {
      this.$refs.filterForm.reset()
      this.listOfRecords = []
      this.filterObj.sort_by = ''
      this.filterObj.sort_asc_or_desc = ''
      setTimeout(() => {
        this.filterObj.from = moment().startOf('month').format('DD.MM.YYYY')
        this.filterObj.till = moment().endOf('month').format('DD.MM.YYYY')
      })
    },
    showHideColumnFilter () {
      this.columnFilterToggle = !this.columnFilterToggle
    },
    filterByHeadersToReport (fields) {
      window.localStorage.setItem('FilterByColumns', JSON.stringify(fields))
      if (fields && fields.length > 0) {
        let getHeaders = this.$format.cloneVariable(this.reportHeaders)
        let filteredFields = []
        for (let i = 0; i < fields.length; i++) {
          let filtered = getHeaders.find(x => x.name === fields[i])
          if (filtered) filteredFields.push(filtered)
        }
        this.clonedHeaders = filteredFields.sort(this.compareTab)
      }
    },
    getActivityByProject (projectIds) {
      let model = { ids: projectIds }
      this.$api.execute('post', '/activities/get_by_project_ids/', model)
        .then((response) => {
          this.listOfActivities = response.data
        })
    },
    generateAsPDF () {
      var getBase64Content = { content: this.getPDFContent() }
      this.$api.execute('post', 'reports/generate_pdf', getBase64Content)
        .then((response) => {
          let fileName = response.data
          window.open(api.defaults.baseURL + 'reports/download/?fileName=' + fileName, '_blank')
        })
    },
    sendReport () {
      if (this.$refs.sendEmailForm.validate()) {
        if (this.sendEmailData.emailIds && this.sendEmailData.emailIds.length > 0) {
          this.isValidEmail = true
          let getMailIDsString = this.sendEmailData.emailIds
          let listOfMailIds = getMailIDsString.split(',')
          if (listOfMailIds && listOfMailIds.length > 0) {
            for (let i = 0; i < listOfMailIds.length; i++) {
              if (listOfMailIds[i]) {
                listOfMailIds[i] = listOfMailIds[i].trim()
                if (this.$format.validEmail(listOfMailIds[i])) this.isValidEmail = false
                else this.isValidEmail = true
              }
            }
          }
          let getHeaders = this.$format.cloneVariable(this.clonedHeaders)
          this.filterObj.columns = [...getHeaders.map(x => x.order)]
          let transformData = { date: { list: ['from', 'till'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
          let model = this.$format.formatModel(this.filterObj, transformData)
          if (!this.isValidEmail) {
            this.sentReportLoading = true
            if (this.sendEmailData.type === 1) {
              model = { to: listOfMailIds, filesendtype: this.sendEmailData.type }
              model.content = this.getPDFContent()
            } else if (this.sendEmailData.type === 2) {
              model.to = listOfMailIds
              model.filesendtype = this.sendEmailData.type
            } else {
              model.to = listOfMailIds
              model.filesendtype = this.sendEmailData.type
              model.content = this.getPDFContent()
            }
            this.$api.execute('post', 'reports/share', model)
              .then((response) => {
                this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.reports.sentSuccess') })
                this.sentReportLoading = false
                this.sendEmailData.emailIds = ''
                this.emailDialog = false
              })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.reports.emailValidation') })
          }
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.reports.emailValidation') })
      }
    },
    getPDFContent () {
      const logoSrc = `${process.env.VUE_APP_URL.split('/api')[0]}/images/app_logo.png`
      const fontLink = 'https://fonts.googleapis.com/css?family=Calibri:400,700,400italic,700italic' // `${process.env.VUE_APP_URL.split('/api')[0]}/css/fonts/stylesheet.css` //
      let keyText = 'Timeliste'
      keyText += this.filterObj.showonlysum ? ', kun timer:' : ': '
      let styleLink = `<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
      <link href="${fontLink}" rel="stylesheet" />
        <style>
        .report_header{background: #354759 !important;color: white;}
        .table{font-family: 'Calibri';}
        table.report > tbody > tr > td p {
          margin-bottom: 2px !important;
        }
        table.report > tbody > tr > td p:last-child {
          margin-bottom: 8px !important;
        }
        .padding-remove { padding: 0 }
        .no--border { border: none !important }
        tbody tr    { page-break-inside:avoid;}
        tbody tr td { text-align: justify;word-break: break-word;}
        .filter-per-activity tbody tr:nth-child(1), .filter-per-customer tbody tr:nth-child(1){
          background: #5bc0de;
          color: white;
        }
        .custom-header-padding-left {
          margin-left: 15px !important;
        }
        </style>`
      let getHTMLContent = `<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" />
        <meta charset="utf-8"/>${styleLink}</head><body>
        <div class="table" style="width:100%; padding:25px 15px !important;">
          <div style="width:50%;float:left !important; margin-bottom: 15px;">
            <p><strong>${keyText}</strong> ${this.filterObj.from} - ${this.filterObj.till}</p>
          </div>
          <div style="margin-bottom: 15px;">
            <img style="max-width:120px !important; float: right !important;" src="${logoSrc}">
          </div>
        </div>
        <div class="container-fluid">${this.$refs.getReportContent.innerHTML}</div></body></html>`
      return btoa(unescape(encodeURIComponent(getHTMLContent)))
    },
    // Generate as XLSX file
    generateAsXLSX () {
      this.$store.commit('showLoader')
      let getHeaders = this.$format.cloneVariable(this.clonedHeaders)
      this.filterObj.columns = [...getHeaders.map(x => x.order)]
      let transformData = { date: { list: ['from', 'till'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
      let model = this.$format.formatModel(this.filterObj, transformData)
      this.$api.execute('post', 'reports/generate_xlsx', model)
        .then((response) => {
          let fileName = response.data
          this.$store.commit('hideLoader')
          window.open(api.defaults.baseURL + 'reports/download/?fileName=' + fileName, '_blank')
        })
    },
    toggleSortFilter () {
      this.sortFilterToggle = !this.sortFilterToggle
    },
    compareTab (a, b) {
      if (a.tab < b.tab) {
        return -1
      } else if (a.tab > b.tab) {
        return 1
      } else {
        return 0
      }
    }
  }
}
</script>
